import {
  BusinessEntityDto,
  FireBatchStatus,
  FireBatchTransferDto,
  MerchantBusinessEntityBankDto,
} from '@up/data';
import { BaseDto } from '../base.dto';

export class FireBatchDto extends BaseDto {
  name: string;
  jobNumber: string;
  fireId: string;
  currency: string;
  businessEntityId: number;
  businessEntityBankId?: number;
  businessEntity: BusinessEntityDto;
  businessEntityBank: MerchantBusinessEntityBankDto;
  iban?: string;
  accountNumber?: string;
  sortCode?: string;
  accountName?: string;
  status: FireBatchStatus;
  statusBeforeArchived: string;
  year: number;
  weekNumber?: number;
  dayNumber?: number;
  firstDate: Date;
  lastDate: Date;
  isBusinessEntityTriggered?: boolean;
  transfers: FireBatchTransferDto[] = [];
  expanded: boolean = false;
}
